function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "link",
  transform: "translate(-2.25 -12.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11654",
  "data-name": "Path 11654",
  d: "M24.265,12.375H14.586a12.336,12.336,0,1,0,0,24.672H26.922A12.336,12.336,0,0,0,38.558,20.6H35.146a4,4,0,0,0-1.029.128,8.224,8.224,0,0,1-7.2,12.208H14.586a8.224,8.224,0,1,1,0-16.448H20.9a16.478,16.478,0,0,1,3.372-4.112Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11655",
  "data-name": "Path 11655",
  d: "M25.839,12.375A12.336,12.336,0,0,0,14.2,28.823h4.516a8.224,8.224,0,0,1,7.12-12.336H38.175a8.224,8.224,0,0,1,0,16.448H31.862a16.531,16.531,0,0,1-3.372,4.112h9.684a12.336,12.336,0,0,0,0-24.672Z",
  transform: "translate(9.308)",
  fill: "#ac1ede"
}));

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57.568,
    height: 24.672,
    viewBox: "0 0 57.568 24.672",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.280f0ba1.svg";
export { ForwardRef as ReactComponent };